import React from 'react';
import styled from 'styled-components';
import { FieldInputProps as FormikFieldInputProps, FormikProps } from 'formik';
import { Box, BoxProps } from '@material-ui/core';
import { Color } from '../../../../server-types';
import { enumToHighlightColorMap, enumToPrimaryColorMap } from '../../../../utils';
import { CreateCategoryFormProps } from './create/types';

interface ColorLabelProps {
    color: Color;
    isActive?: boolean;
}

const ColorLabel = styled.label<ColorLabelProps>`
    ${({ color, theme, isActive }) => `
        background: ${isActive ? enumToHighlightColorMap[color] : 'transparent'};
        width: ${theme.spacing(6)}px;
        height: ${theme.spacing(6)}px;
        border-radius: ${theme.shape.borderRadius}px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        margin: 0 ${theme.spacing(0.5)}px;
        &:after {
            content: '';
            width: ${theme.spacing(4.5)}px;
            height: ${theme.spacing(4.5)}px;
            position: absolute;
            top: 50%;
            left: 50%;
            background: ${enumToPrimaryColorMap(theme, color)};
            transform: translate(-50%, -50%);
            z-index: 0;
            border-radius: ${theme.shape.borderRadius}px;
            z-index: -1;
        }
    `}
`;

interface FieldProps<T, K> extends FormikFieldInputProps<K> {
    formikProps: FormikProps<T>;
}

export const ColorInput = ({ formikProps,...props }: FieldProps<CreateCategoryFormProps, Color>) => (
    <ColorLabel isActive={props.checked} color={props.value}>
        <input hidden type='radio' {...props} />
    </ColorLabel>
);

interface ColorMarkerProps extends BoxProps {
    color: Color;
}

export const ColorMarker = styled(({ color, ...other }: ColorMarkerProps) => <Box {...other} />)`
    ${({ color, theme }) => `
        border-radius: ${theme.shape.borderRadius}px;
        width: ${theme.spacing(6)}px;
        height: ${theme.spacing(6)}px;
        background: ${enumToPrimaryColorMap(theme, color)};
    `}
`;
